import React, { useState, useEffect } from "react";
import "./Navbar.css";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);

      const sections = document.querySelectorAll("section[id]");
      let current = "";
      sections.forEach((s) => {
        if (window.scrollY >= s.offsetTop - 120) current = s.id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleLink = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`} aria-label="Main navigation">
      <a href="#hero" className="nav-logo" onClick={(e) => handleLink(e, "#hero")}>
        KS<span>.dev</span>
      </a>

      <ul className={`nav-links${menuOpen ? " open" : ""}`}>
        {navLinks.map(({ label, href }) => (
          <li key={label}>
            <a
              href={href}
              className={active === href.slice(1) ? "active" : ""}
              onClick={(e) => handleLink(e, href)}
            >
              {label}
            </a>
          </li>
        ))}
        <li className="nav-links__mobile-cta">
          <a
            href="https://www.linkedin.com/in/kashish-shukla-dev/"
            target="_blank"
            rel="noreferrer"
            className="nav-cta nav-cta--mobile"
          >
            Hire Me
          </a>
        </li>
      </ul>

      <a
        href="https://www.linkedin.com/in/kashish-shukla-dev/"
        target="_blank"
        rel="noreferrer"
        className="nav-cta"
      >
        Hire Me
      </a>

      <button
        className={`nav-burger${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen((p) => !p)}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>

      {menuOpen && (
        <button
          className="nav-overlay"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </nav>
  );
}

export default Navbar;
